type ParseDate = (dateAsStr: string | null | undefined) => Date | undefined;

export const parseDate: ParseDate = dateAsStr => {
    return typeof dateAsStr === 'string' ? new Date(dateAsStr) : undefined;
};
